import { render, staticRenderFns } from "./MaintainAddOrUpdate.vue?vue&type=template&id=2c0258ca"
import script from "./MaintainAddOrUpdate.vue?vue&type=script&lang=js"
export * from "./MaintainAddOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports